import { localeAwareFormat } from 'app/lib/date';
import type { PressableProps } from 'react-native';
import { Pressable, StyleSheet } from 'react-native';
import { Row } from '../box';
import { Text } from '../text';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { useTheme } from '@shopify/restyle';
import type { Theme } from 'app/shopify';

interface CalendarControlsProps {
  current: Date;
  disableNext?: boolean;
  disablePrevious?: boolean;
  onNextPress: () => void;
  onPreviousPress: () => void;
}

export function CalendarControls({
  current,
  disableNext,
  disablePrevious,
  onNextPress,
  onPreviousPress,
}: CalendarControlsProps) {
  const theme = useTheme<Theme>();
  const commonButtonProps: Partial<PressableProps> = {
    hitSlop: {
      bottom: 10,
      left: 10,
      right: 10,
      top: 10,
    },
  };

  return (
    <Row alignItems="center" justifyContent="space-between">
      <Pressable
        {...commonButtonProps}
        disabled={disablePrevious}
        onPress={onPreviousPress}
        style={({ pressed }) => [
          styles.navigationButton,
          {
            backgroundColor: theme.colors['surface.tertiary-neutral'],
            opacity: disablePrevious ? 0.35 : pressed ? 0.6 : 1,
          },
        ]}
        testID="calendar-previous-month"
      >
        <IconChevronLeft color={theme.colors['text.primary']} size={20} strokeWidth={ICON_STROKE_WIDTH} />
      </Pressable>

      <Text fontSize={18} fontWeight="700" textAlign="center">
        {localeAwareFormat(current, 'MMMM y')}
      </Text>

      <Pressable
        {...commonButtonProps}
        disabled={disableNext}
        onPress={onNextPress}
        style={({ pressed }) => [
          styles.navigationButton,
          {
            backgroundColor: theme.colors['surface.tertiary-neutral'],
            opacity: disableNext ? 0.35 : pressed ? 0.6 : 1,
          },
        ]}
        testID="calendar-next-month"
      >
        <IconChevronRight color={theme.colors['text.primary']} size={20} strokeWidth={ICON_STROKE_WIDTH} />
      </Pressable>
    </Row>
  );
}

const styles = StyleSheet.create({
  navigationButton: {
    alignItems: 'center',
    borderRadius: 18,
    height: 36,
    justifyContent: 'center',
    width: 36,
  },
});
